import { type RootState } from '@reducers';
import { Col, Form, InputNumber, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { useAppDispatch } from '../../hooks/use-app-dispatch';
import { dimensionsUpdate } from '../../reducers/product/reducer';
import FormSubmitFooter from '../form-submit-footer';

interface IForm {
  weight: number;
  length: number;
  width: number;
  height: number;
}

function Dimensions(): React.ReactElement {
  const dispatch = useAppDispatch();
  const dimensions = useSelector((s: RootState) => s.Product.dimensions);
  const inProcess = useSelector((s: RootState) => s.Product.inProcess);
  const productUUID = useSelector((s: RootState) => s.Product.uuid);
  const productUpdatedAt = useSelector((s: RootState) => s.Product.updatedAt);

  const [form] = Form.useForm<IForm>();

  const [initialValues, setInitialValues] = useState({});

  useEffect((): void => {
    const initialValuesUE: IForm = {
      weight: dimensions.weight,
      length: dimensions.length,
      width: dimensions.width,
      height: dimensions.height,
    };

    setInitialValues(initialValuesUE);

    form.setFieldsValue(initialValuesUE);
  }, [dimensions, productUpdatedAt]);

  const onFinish = (values: IForm) => {
    dispatch(
      dimensionsUpdate(
        productUUID,
        values.weight,
        values.width,
        values.height,
        values.length,
      ),
    );
  };

  return (
    <>
      <Form
        form={form}
        onFinish={onFinish}
        layout="vertical"
        initialValues={initialValues}
      >
        <Row>
          <Col span={24}>
            <Form.Item
              name="weight"
              label="Weight (Kg)"
              rules={[
                {
                  required: true,
                },
                {
                  type: 'number',
                },
              ]}
            >
              <InputNumber disabled={inProcess} />
            </Form.Item>

            <Form.Item
              name="length"
              label="Length (m)"
              rules={[
                {
                  required: true,
                },
                {
                  type: 'number',
                },
              ]}
            >
              <InputNumber disabled={inProcess} />
            </Form.Item>

            <Form.Item
              name="width"
              label="Width (m)"
              rules={[
                {
                  required: true,
                },
                {
                  type: 'number',
                },
              ]}
            >
              <InputNumber disabled={inProcess} />
            </Form.Item>

            <Form.Item
              name="height"
              label="Height (m)"
              rules={[
                {
                  required: true,
                },
                {
                  type: 'number',
                },
              ]}
            >
              <InputNumber disabled={inProcess} />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <FormSubmitFooter
              inProcess={inProcess}
              updatedAt={productUpdatedAt}
            />
          </Col>
        </Row>
      </Form>
    </>
  );
}

export default React.memo(Dimensions);
